module.exports = __webpack_public_path__ + "static/img/2.8374842.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/2.png
// module id = NpxG
// module chunks = 1